<script setup lang="ts">
  // eslint-disable-next-line fsd/layer-imports
  import { useProfile } from '@/entities/profile'

  import BaseDialog from './BaseDialog.vue'

  const isOpen = defineModel<boolean>({ required: true })
  const { logout } = useProfile()
</script>

<template>
  <BaseDialog
    v-model="isOpen"
    confirm-label="base_yes"
    cancel-label="base_no"
    message="signout_popup_question"
    @confirm="logout"
  />
</template>

<style scoped lang="scss"></style>
